import { AttioTeamMemberResponse } from '../attio.types';
import { BaseAttioService } from './BaseAttioService';

// Service-specific types
export interface AttioConsultantData {
  name: string;
  imageSrc: string;
  email: string;
}

export class AttioConsultantService extends BaseAttioService {
  constructor() {
    super('AttioConsultantService');
  }
  /**
   * Get other consultant details for a valuation record
   */
  async getOtherConsultant(otherConsultantRecordId: string, signal?: AbortSignal): Promise<AttioConsultantData> {
    try {
      const response = await this.get<AttioTeamMemberResponse>(
        this.endpoints.retrieveTeamByRecordId(otherConsultantRecordId),
        signal
      );
      const responseData = response.data.values;
      const name = responseData.name?.[0]?.value || '-';
      const email = responseData.email?.[0]?.value || '-';
      const imageSrc = responseData.profile_image_url?.[0]?.value || '-';
      return {
        name,
        imageSrc,
        email,
      };
    } catch (error) {
      console.error('Error fetching other consultant:', error);
      return {
        name: '-',
        imageSrc: '-',
        email: '-',
      };
    }
  }
}
